import React from "react";
import TreeDraggable from "../../../global/tree/TreeDraggable";
import propTypes from "prop-types";

const markUnpublishedNodes = (nodes = []) => {
  return nodes.map((node) => {
    const children = node.children ? markUnpublishedNodes(node.children) : [];

    const isUnpublished = node.isPublished === null;
    const hasUnpublishedInChildren = children.some(
      (child) => child.hasUnpublished || child.isPublished === null
    );

    return {
      ...node,
      children,
      hasUnpublished: isUnpublished || hasUnpublishedInChildren,
    };
  });
};

const AddFolderTree = ({ setDisableSave, data }) => {
  const nodes = markUnpublishedNodes(data);
  return (
    <TreeDraggable
      data={nodes}
      count={1}
      depth={1}
      treeIndexes={[0]}
      setDisableSave={setDisableSave}
    />
  );
};
AddFolderTree.propTypes = {
  setDisableSave: propTypes.func,
  data: propTypes.array,
};
export default AddFolderTree;
